import { render, staticRenderFns } from "./TheLibraryCurrentDocument.vue?vue&type=template&id=3663e0a0&"
import script from "./TheLibraryCurrentDocument.vue?vue&type=script&lang=js&"
export * from "./TheLibraryCurrentDocument.vue?vue&type=script&lang=js&"
import style0 from "./TheLibraryCurrentDocument.vue?vue&type=style&index=0&id=3663e0a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports